import React, { Component, useReducer } from 'react';
import {Table, Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import { Triangle } from 'react-loader-spinner'

  class OrgTrainers extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        org_trainers: [],
        loading: true,
        trainer_email: ''
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.AddTrainerToOrganisation = () => {
        this.setState({loading: true})

        const { cookies } = this.props;
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('trainer_email', this.state.trainer_email)
  
        axios.post(Backend_Url + 'addTrainerToOrganisation', data)
        .then((res) => {
            let result = res.data
            if (result == 'Email not registered on this platform'){
                alert('No user registered under this email has been found on this platform')
            }else if (result == 'Account is not registered under a trainer'){
                alert('An account has been found but is not registered under a trainer')
            }else if (result == 'Successful'){
                alert('Trainer added successfully. Reloading trainer list.')
                this.setState({trainer_email: ''})
                this.GetTrainers()
            }else{
              alert('Something went wrong. Check your data and try again.')
            }
            this.setState({loading: false})
        }).catch((error) => {
            alert('An error occured while trying to add trainer, please check your data and try again.')
            this.setState({loading: false})
        })
      }

      this.GetTrainers = () => {
        this.setState({loading: true})
        const { cookies } = this.props;
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
  
        axios.post(Backend_Url + 'getOrgTrainers', data)
        .then((res) => {
            let result = res.data
              this.setState({org_trainers: result, loading: false})
        }).catch((error) => {
            this.GetTrainers()
        })
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)
      this.GetTrainers()
    }




    render() {
      if (this.state.loading == true){
        return<Row>
            <Helmet>
              <title>ORGANISATION TRAINERS - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                ONFIT
              </h1>
              <br/><br/>
              <Triangle
                  color="#1FACED"
                  height={130}
                  width={130}
              />
              <h3 style={{marginTop: '50px', color: '#1FACED'}}>
                Loading...
              </h3>
              <h6 style={{marginTop: '50px'}}>
                  Taking too long to load? Check your internet connection and reload the page.
              </h6>
              <br/><br/>
            </div>
        </Row>
      }

      var trainers = this.state.org_trainers
      var trainers_map = trainers.map((trainer, index) => {
        return<tr onClick={() => this.OnClickTrainer(index)}>
          <td>{index+1}</td>
          <td>{trainer.name}</td>
          <td>{trainer.email}</td>
          <td>{trainer.date_joined}</td>
        </tr>
      })

      return (
        <Row>
            <Helmet>
              <title>ORGANISATION TRAINERS - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <Container>
                <br/>
                <h4 style={{}}>
                  Organisation Trainers
                </h4>
                <br/>
                <h6 style={{textAlign: 'left'}}>
                  Add Trainer:
                </h6>
                <br/>
                <Input name='trainer_email' type='text' value={this.state.trainer_email} style={{border: 'none', borderBottom: '1px solid silver', width: '100%'}}
                    placeholder="Enter trainer's email address" onChange={this.HandleChange}/>
                <br/><br/>
                <Button onClick={this.AddTrainerToOrganisation} style={{color: '#ffffff', fontWeight: 'bold', border: '3px solid #1faced', borderRadius: '20px', backgroundColor: '#1faced'}}>
                    Add Trainer To Organisation
                </Button>
                <br/><br/>
                <Table style={{}}>
                  <thead style={{color: 'inherit'}}>
                      <tr>
                      <th width='20%'>Trainer Number</th>
                      <th width='20%'>Name</th>
                      <th width='30%'>Email</th>
                      <th width='20%'>Date Joined</th>
                    </tr>
                  </thead>
                  <tbody>
                    {trainers_map}
                  </tbody>
                </Table>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(OrgTrainers);